/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Ladda from 'ladda';
import Backbone from 'backbone';
import moment from 'moment';
import { View } from 'backbone.marionette';

import GetReportData from '../../services/GetReportData';
import GenerateReportCSV from '../../services/GenerateReportCSV';
import DownloadDocumentFromFS from '../../../common/util/downloadDocumentFromFS';

import ReportResultsGridView from '../ReportResultsGridView/ReportResultsGridView';

import tmplReportsView from './ReportsView.hbs';

const ReportsView = View.extend({
  template: tmplReportsView,

  ui: {
    reportResultsGridView: '.report-results-grid-view',
    runReportBtn: '.run-report-button',
    downloadReportBtn: '.download-report-button',
    reportSelect: '.report-select',
    selectedReport: '.report-select option:selected'
  },

  events: {
    'click @ui.runReportBtn': 'onClickRunReport',
    'click @ui.downloadReportBtn': 'onClickDownloadReport',
    'change @ui.selectedReport': 'onReportChange'
  },

  regions: {
    reportResultsGridView: '@ui.reportResultsGridView'
  },

  onRender() {},

  async onClickRunReport(e) {
    e.preventDefault();
    const spinner = Ladda.create(this.ui.runReportBtn[0]);
    spinner.start();
    const selectedReportId = this.ui.reportSelect.val();
    const reportData = await GetReportData(selectedReportId);
    this.model.set('count', reportData.count);
    this.reportResultsGridView = new ReportResultsGridView({
      pageSize: 10,
      model: new Backbone.Model(reportData)
    });
    this.$('.result-count').empty().append(`<span><b>Total Result Count: ${reportData.count}</b></span>`);
    this.showChildView('reportResultsGridView', this.reportResultsGridView);
    spinner.stop();
  },

  async onClickDownloadReport(e) {
    e.preventDefault();
    const spinner = Ladda.create(this.ui.downloadReportBtn[0]);
    spinner.start();
    const reportFile = await GenerateReportCSV(this.ui.reportSelect.val());
    const fileName = moment().format('YYYYMMDD') + '_' + this.ui.reportSelect.find('option:selected').text() + '.csv';
    DownloadDocumentFromFS({
      tempFileName: reportFile,
      fileName: fileName
    });
    spinner.stop();
  }
});

export default ReportsView;
